import { render, staticRenderFns } from "./userNameTimeStamp.vue?vue&type=template&id=4b264516"
import script from "./userNameTimeStamp.vue?vue&type=script&lang=js"
export * from "./userNameTimeStamp.vue?vue&type=script&lang=js"
import style0 from "./userNameTimeStamp.vue?vue&type=style&index=0&id=4b264516&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports